let isPatched = false;

/**
 * Patches console.error to filter out specific errors before they are logged
 * - Addresses the harmless LockManager contention message caused by Supabase's token synchronization logic. Can be safely ignored.
 *  See https://github.com/supabase/supabase-js/issues/936
 */
export function setupConsoleErrorPatching() {
  // Guard: only patch once
  if (isPatched) {
    return;
  }

  const originalError = console.error;

  console.error = (...args: unknown[]) => {
    const shouldSuppress = args.some((arg) => {
      return isSupabaseLockError(arg);
    });

    if (shouldSuppress) {
      return;
    }

    originalError.apply(console, args);
  };

  isPatched = true;
}

function isSupabaseLockError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  const errorMessage = typeof error === 'string' ? error : (error as Error)?.message;

  return (
    errorMessage?.includes('NavigatorLockAcquireTimeoutError') || errorMessage?.includes('Navigator LockManager lock')
  );
}
